import LogRocket from 'logrocket';

if (process.env.NODE_ENV !== 'production') {
    console.log('IN DEV MODE');
    // React.Perf = require('react-addons-perf');
}
else {
    require('./fullstory');
    LogRocket.init('zg2tcu/leaflogix-foh');
}
import App from './components/app/App.react';
import { AppContainer } from 'react-hot-loader';
import { datadogRum } from '@datadog/browser-rum';
import { pendoInit } from './pendo';

pendoInit('28a64b1a-322b-48a4-6319-f6c7ad86b901');
datadogRum.init({
    applicationId: 'bd1e4baa-7fa9-4db4-9e0f-fa6ff5a104c4',
    clientToken: 'pub6e033f8330cb8ef861068304cb1cb8e2',
    site: 'datadoghq.com',
    service:'pos3',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 0,
    replaySampleRate: 0,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingOrigins: [/https:\/\/.*\.leaflogix\.net/],
});

const render = App => {
    ReactDOM.render(
        <AppContainer>
            <App />
        </AppContainer>,

        document.getElementById('template')
    );
};

render(App);

datadogRum.startSessionReplayRecording();

if (module.hot) {
    module.hot.accept('./components/app/App.react', () => render(App));
}



// import component from './components/app/App.react';
// document.body.appendChild(component());



// WEBPACK FOOTER //
// ./ui_src/app/index.js